import React, { useEffect, useMemo, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
// import { Button, OverlayTrigger } from "react-bootstrap";
import {MdFilterList, MdAddCircle, MdEdit,MdDelete  } from "react-icons/md";
import { Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import loading from "../../../assets/images/common/loading.gif";
import AppDataGrid from "../../../components/common/AppDataGrid";
import { Button, Modal, Row, Col, Form, OverlayTrigger } from "react-bootstrap";

function AccountGrouptypes() {
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const userData = sessionStorage.getItem("user");
  const userObj = userData ? JSON.parse(userData) : {};
   const [showFilterModal, setShowFilterModal] = useState(false);
      const handleShowFilterModal = () => setShowFilterModal(true);
      const handleCloseFilterModal = () => setShowFilterModal(false);
      

  const [rows, setRows] = useState([]);
  const [grouptypes, setGrouptypes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [filter, setFilter] = useState({
  group_type_id: "",
  subgroup_id: "",
});

  // ---- Fetch Group Types for showing name in grid (if API doesn't return name) ----
  const fetchGroupTypes = async () => {
    try {
      const res = await axios.get(`${baseUrl}/getgrouptypes/`, {
        params: { action: "READ", school_id: userObj.school_id },
      });
      setGrouptypes(res.data?.group_types || []);
    } catch (e) {
      console.error(e);
    }
  };

  // ---- Fetch SubGroups list ----
  // If you don't have a list endpoint yet, you can add one later.
  // For now, I kept it as /getsubgroupmaster/ (change if your actual endpoint differs).
  const fetchSubGroups = async () => {
    try {
      // ✅ Change this endpoint if needed
      const res = await axios.get(`${baseUrl}/getsubgroupmaster`, {
        params: { school_id: userObj.school_id },
      });

      const data = Array.isArray(res.data?.subgroups)
        ? res.data.subgroups
        : Array.isArray(res.data)
        ? res.data
        : [];

      setRows(data);
    } catch (e) {
      console.error(e);
      setRows([]);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    Promise.all([fetchGroupTypes(), fetchSubGroups()]).finally(() =>
      setIsLoading(false)
    );
    // eslint-disable-next-line
  }, []);

  const handleEditClick = (subgroup_id) => {
    const selected = rows.find((r) => r.subgroup_id === subgroup_id);
    if (!selected) return toast.error("Record not found");
    navigate("/finance/account-grouptypes/add", { state: { rowData: selected } });
  };

  const searchableColumns = useMemo(
    () => [
      (r) => r.subgroup_name,
      (r) => r.sub_group_code,
      (r) => r.group_type_name,
    ],
    []
  );

  const handleDeleteClick = async (subgroup_id) => {
  if (!window.confirm("Are you sure you want to set this record as Inactive?")) return;

  try {
    await axios.post(`${baseUrl}/subgroupmasterdelete/`, {
      subgroup_id: subgroup_id,
      school_id: userObj.school_id,
      deleted_by: userObj?.user_name || "admin",
    });

    toast.success("Record set to InActive successfully");

    // Refresh list
    fetchSubGroups();
  } catch (error) {
    console.error("Delete Error:", error);
    toast.error("Failed to delete record");
  }
};

const handleFilterSearch = async (e) => {
  e.preventDefault();

  const formData = {
    school_id: userObj.school_id,
    group_type_id: filter.group_type_id
      ? Number(filter.group_type_id)
      : null,
    // subgroup_id: filter.subgroup_id
    //   ? Number(filter.subgroup_id)
    //   : null,
  };

  try {
    const response = await axios.post(
      `${baseUrl}/subgroupmasterfilter/`,
      formData,
      { headers: { "Content-Type": "application/json" } }
    );

    setRows(response.data || []);
    handleCloseFilterModal();
  } catch (error) {
    console.error("Filter Error:", error);
    toast.error("Failed to filter records");
  }
};

const handleReset = async (e) => {
  e.preventDefault();

  setFilter({
    group_type_id: "",
    subgroup_id: "",
  });

  handleCloseFilterModal();
  fetchSubGroups(); // reload original list
};



  const filteredRows = useMemo(() => {
    const q = (searchQuery || "").toUpperCase().replace(/[-\s]+/g, "");
    return (rows || []).filter((r) =>
      searchableColumns.some((sel) => {
        const v = String(sel(r) || "").toUpperCase().replace(/[-\s]+/g, "");
        return v.includes(q);
      })
    );
  }, [rows, searchQuery, searchableColumns]);

  const columns = [
    {
      field: "group_type_name",
      headerName: "Group Type",
      flex: 1,
      valueGetter: (params) => {
        // If your API already returns group_type_name, it will show directly
        // Else map using grouptypes
        if (params.row.group_type_name) return params.row.group_type_name;

        const gt = grouptypes.find(
          (g) => Number(g.group_type_id) === Number(params.row.group_type_id)
        );
        return gt?.group_type_name || "";
      },
      renderCell: (params) => (
        <Tooltip title={params.value || ""}>
          <span className="cell-wrap">{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "subgroup_name",
      headerName: "Sub Group Name",
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value || ""}>
          <span className="cell-wrap">{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "sub_group_code",
      headerName: "Sub Group Code",
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value || ""}>
          <span className="cell-wrap">{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "is_active",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value || ""}>
          <span className="cell-wrap">{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      sortable: false,
      renderCell: (params) =>
        params.row?.subgroup_id ? (
          <div className="tableActions">
            <Tooltip title="Edit" arrow>
              <span
                className="commonActionIcons"
                onClick={() => handleEditClick(params.row.subgroup_id)}
              >
                <MdEdit />
              </span>
            </Tooltip>
            <Tooltip title="Delete" arrow>
          <span
            className="commonActionIcons"
            onClick={() => handleDeleteClick(params.row.subgroup_id)}
          >
            <MdDelete />
          </span>
        </Tooltip>
          </div>
        ) : null,
    },
  ];

  return (
    <div className="pageBody">
      <ToastContainer />

      <div className="commonDataTableHead">
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="d-flex align-items-center" style={{ gap: "10px" }}>
            <h6 className="commonTableTitle">Account Sub Groups</h6>
          </div>

          <div>
            <input
              type="text"
              placeholder="Search..."
              value={searchQuery}
              className="searchInput"
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          <div className="d-flex align-items-center" style={{ gap: 6 }}>
             <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Filter</Tooltip>}>
                                        <Button className="secondaryBtn" variant="secondary" onClick={handleShowFilterModal}>
                                            <MdFilterList />
                                        </Button>
                                    </OverlayTrigger>
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip-top">Add</Tooltip>}
            >
              <Button
                className="primaryBtn"
                variant="primary"
                onClick={() => navigate("/finance/account-grouptypes/add")}
              >
                <MdAddCircle />
              </Button>
            </OverlayTrigger>
          </div>
        </div>
      </div>

      <div className="commonTable height100">
        <div className="tableBody">
          {isLoading ? (
            <div className="loadingContainer">
              <img src={loading} alt="Loading..." className="loadingGif" />
            </div>
          ) : (
            <AppDataGrid
              rows={filteredRows}
              columns={columns}
              getRowId={(r) => r.subgroup_id}
              showToolbar={false}
              pagination
              pageSizeOptions={[10, 20, 50]}
              density="compact"
              maxHeight={500}
            />
          )}
        </div>
      </div>
      {/* Filter Modal */}
<Modal show={showFilterModal} onHide={handleCloseFilterModal} className="commonFilterModal">
  <Modal.Header closeButton className="modalHeaderFixed">
    <Modal.Title>Filter</Modal.Title>
  </Modal.Header>

  <Modal.Body className="modalBodyScrollable">
    <Row>

      <Col xs={12}>
        <div className="commonInput">
          <Form.Group controlId="group_type_id">
            <Form.Label>Group Type</Form.Label>
            <Form.Select
              value={filter.group_type_id}
              onChange={(e) =>
                setFilter({ ...filter, group_type_id: e.target.value })
              }
            >
              <option value="">Select Group Type</option>
              {(grouptypes || []).map((gt) => (
                <option key={gt.group_type_id} value={gt.group_type_id}>
                  {gt.group_type_name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </div>
      </Col>

      {/* <Col xs={12}>
        <div className="commonInput">
          <Form.Group controlId="subgroup_id">
            <Form.Label>Sub Group ID</Form.Label>
            <Form.Control
              type="number"
              placeholder="Enter Sub Group ID"
              value={filter.subgroup_id}
              onChange={(e) =>
                setFilter({ ...filter, subgroup_id: e.target.value })
              }
            />
          </Form.Group>
        </div>
      </Col> */}

    </Row>
  </Modal.Body>

  <Modal.Footer className="modalFooterFixed">
    <Button variant="secondary" className="btn-info clearBtn me-2" onClick={handleReset}>
      Reset
    </Button>

    <div>
      <Button
        variant="secondary"
        className="btn-danger secondaryBtn me-2"
        onClick={handleCloseFilterModal}
      >
        Cancel
      </Button>

      <Button
        variant="primary"
        className="btn-success primaryBtn"
        onClick={handleFilterSearch}
      >
        Search
      </Button>
    </div>
  </Modal.Footer>
</Modal>
      
    </div>

    

    
  );
  
}

export default AccountGrouptypes;
